<template>
  <div class="pull-refresh-slot">
    <VanCircle
      v-model="currentPer"
      color="#FB006E"
      layer-color="#EFEFEF"
      size="100%"
      :stroke-width="100"
    />
  </div>
</template>

<script>
import { Circle } from 'vant'

export default {
  props: {
    distance: {
      type: Number,
      default: 0,
    },
    criticalValue: {
      type: Number,
      default: 120,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VanCircle: Circle,
  },
  computed: {
    currentPer: {
      get () {
        return (
          this.fixed
            ? 50
            : this.distance >= this.circleHeight
              ? Math.min(((this.distance - this.circleHeight) / (this.criticalValue || 1)).toFixed(2) * 100, 50)
              : 0
        )
      },
      set (val) {
        return val
      },
    },
  },
  data () {
    return {
      circleHeight: 0,
    }
  },
  mounted () {
    const dom = document.querySelector('.pull-refresh-slot')

    if (dom) {
      this.circleHeight = dom.getBoundingClientRect().height
    }
  },
}
</script>

<style lang="scss" scoped>
  .pull-refresh-slot {
    @include flex;
    width: 1em;
    height: 1em;
    font-size: 40px;
    margin: auto;
  }
</style>
